<script setup lang="ts">
export interface AccordionPanelProps {
  idx: number
  active: boolean
  layout: SectionServicesListRecord['layout']
}

defineProps<AccordionPanelProps>()
const emit = defineEmits(['expand'])

const id = useId()
const { isDesktop } = useDevice()
const isAnimating = ref(false)

const expand = () => {
  if (isAnimating.value) {
    return
  }
  emit('expand')
}

function setHeight(el: HTMLElement) {
  isAnimating.value = true
  el.style.height = el.scrollHeight + 'px'
}

function unsetHeight(el: HTMLElement) {
  isAnimating.value = false
  el.style.height = ''
}
</script>

<template>
  <div>
    <button
      type="button"
      class="flex w-full cursor-pointer items-center text-left mix-blend-difference transition-colors"
      :class="[
        {
          'text-4xl hover:text-white lg:text-6xl-m': layout === 'Medium',
          'text-4xl-m lg:text-8xl-m': layout === 'Large'
        },
        active ? 'text-white' : 'text-neutral-700'
      ]"
      :aria-controls="`acc-${id}_panel-${idx}`"
      :aria-expanded="active"
      @click="expand($event)"
    >
      <slot name="title" />
    </button>
    <Transition
      :name="isDesktop && layout === 'Large' ? 'service-lg' : isDesktop ? 'service' : 'accordion'"
      @enter="setHeight"
      @after-enter="unsetHeight"
      @before-leave="setHeight"
      @after-leave="unsetHeight"
    >
      <div
        v-show="active"
        :id="`acc-${id}_panel-${idx}`"
        class="overflow-hidden"
        :aria-hidden="!active"
      >
        <slot name="content" />
      </div>
    </Transition>
  </div>
</template>
